import { ProductLineCodesTypes } from '../../business-lines/product-lines-codes';

export interface GetProjectLotsRequest {
  // required
  projectId: number;
  productLineCode: ProductLineCodesTypes;
}
